module.exports = __webpack_public_path__ + "static/media/choithramsOrangeS.4cf4b5e4.png";